import { render, staticRenderFns } from "./ReviewBox.vue?vue&type=template&id=7a0cc092&scoped=true&lang=pug&"
import script from "./ReviewBox.vue?vue&type=script&lang=ts&"
export * from "./ReviewBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0cc092",
  null
  
)

export default component.exports